import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from '../../contexts/GlobalContext';
import './Cookies.css'
import getImage from "../../useFull/getImage";
import Btn from "../Btn/Btn";
import { getCookie, setCookieWithOneYearExpiration } from "../../useFull/cookieController";
const COOKIE_ACCEPTED_NAME = 'isAcceptedC'
const COOKIE_EXPECTED_VALUE = 'accepted'


const Cookies = () => {
    const { state } = useContext(GlobalContext);
    const language = state.language || 'pt-br';
    const { legend, legendBtn } = require(`../../assets/languages/${language}/cookieBallon.json`);
    const [show, setShow] = useState(false);
    const [hide, setHide] = useState(false);

    const handleAccept = () => {
        setShow(false)
        setTimeout(() => { 
            setCookieWithOneYearExpiration(COOKIE_ACCEPTED_NAME, COOKIE_EXPECTED_VALUE);
            setHide(true)
        }, 1000);
    }

    useEffect(() => {
        setTimeout(() => {
            setShow(true)
        }, 1000);
    }, []);

    return (getCookie(COOKIE_ACCEPTED_NAME) !== COOKIE_EXPECTED_VALUE) && !hide &&
        <div className='main-container cookie-container'>
            <section className="section-container">
                <div className={`cookie-ballon w-box-shadow ${show && 'fade-in'}`}>
                    <div className="cookie-icon">
                        <div className="bg-icon" style={{ backgroundImage: `url(${getImage('icons', 'cookie.png')})` }} />
                    </div>
                    <div className="cookie-legend">
                        <span dangerouslySetInnerHTML={{ __html: legend }}></span>
                    </div>
                    <div className="cookie-action">
                        <Btn label={legendBtn} _function={handleAccept} />
                    </div>
                </div>
            </section>
        </div>

}

export default Cookies